import { getToken } from "firebase/messaging";
import { useCallback, useEffect, useRef } from "react";
import { messaging } from "../../config/firebaseConfig";
import { useFormData } from "../../helpers/FormDataProvider";
import useAirlineAdminApi from "../../services/api/useAirlineAdminApi";
import NotificationAlert from "./NotificationAlert";

const NotificationHandler = () => {
  const { userData } = useFormData();
  const { addDeviceToken } = useAirlineAdminApi(userData.isAAUser);
  const initializationAttempted = useRef(false);

  const initializeNotifications = useCallback(async () => {
    if (initializationAttempted.current) return;
    initializationAttempted.current = true;

    try {
      if (!messaging) {
        console.warn("Firebase Cloud Messaging is not available");
        return;
      }

      let permission = Notification.permission;

      if (permission === "default") {
        permission = await Notification.requestPermission();
      }

      if (permission === "granted") {
        let token;
        if (process.env.NODE_ENV === "production") {
          token = await getToken(messaging, {
            vapidKey: `REACT_APP_VAPID_KEY_PLACEHOLDER`,
          });
        } else {
          token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_VAPID_KEY,
          });
        }
        try {
          await addDeviceToken(token);
        } catch (error) {
          console.error("Error registering device token:", error);
        }
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  }, [addDeviceToken]);

  useEffect(() => {
    if (userData?.id && !initializationAttempted.current) {
      initializeNotifications();
    }
  }, [userData?.id, initializeNotifications]);

  return <NotificationAlert />;
};

export default NotificationHandler;
